/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {ProductGridCardSkeleton} from "../../products/ProductGridCardSkeleton";

export const ProductFinderRowSkeleton = () => (
    <>{[...Array(4)].map((item, i) => <ProductGridCardSkeleton key={i}/>)}</>
)
